// extracted by mini-css-extract-plugin
export default {"dropdown":"DropdownPopover_dropdown__Q-mvy"};